class AboutPage {
  constructor() {
    this.setupOfficeGradients();

    this.modal = document.querySelector('.js-reagent-modal');
    if (!this.modal) {
      return;
    }
    this.openers = document.querySelectorAll('.js-reagent-modal-open');
    this.closers = this.modal.querySelectorAll('.js-reagent-modal-close');
    this.scrollTop = 0;
    this.bind();
  }

  setupOfficeGradients() {
    const sections = [
      {
        area: document.querySelector('.js-world-area'),
        list: document.querySelector('.js-world-list'),
      },
    ];

    const mm = gsap.matchMedia();

    sections.forEach(({ area, list }) => {
      if (!area || !list) return;

      const gradient = area.querySelector('.js-sticky-gradient');
      if (!gradient) return;

      gsap.set(gradient, { autoAlpha: 0 });

      const showGradient = () => {
        gsap.to(gradient, {
          autoAlpha: 1,
          duration: 0.6,
          ease: 'power3.out',
          overwrite: true,
        });
      };

      const hideGradient = () => {
        gsap.to(gradient, {
          autoAlpha: 0,
          duration: 0.6,
          ease: 'power3.out',
          overwrite: true,
        });
      };

      // PC: リスト上端が画面中央に来たとき
      mm.add('(min-width: 768px)', () => {
        ScrollTrigger.create({
          trigger: list,
          start: 'top center',
          end: 'bottom top',
          onEnter: showGradient,
          onLeave: hideGradient,
          onEnterBack: showGradient,
          onLeaveBack: hideGradient,
        });
      });
    });
  }

  bind() {
    this.openers.forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.closers.forEach((closer) => {
      closer.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.scrollTop = window.scrollY || 0;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-reagent-modal-open');
    document.documentElement.style.top = `${-this.scrollTop}px`;
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-reagent-modal-open');
    document.documentElement.style.top = '';
    window.scrollTo(0, this.scrollTop);
  }
}

class DataPage {
  constructor() {
    if (!document.querySelector('.p-data')) {
      return;
    }
    this.initCountUp();
  }

  initCountUp() {
    const targets = document.querySelectorAll('.p-data .js-data-count');
    if (!targets.length) {
      return;
    }

    const formatInteger = (value, useSeparator) => {
      const int = Math.floor(value);
      if (!useSeparator) {
        return String(int);
      }
      return String(int).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const formatDecimalPart = (value, decimals) => {
      if (decimals <= 0) {
        return '';
      }
      const fraction = Number(value).toFixed(decimals).split('.')[1] || '';
      return `.${fraction}`;
    };

    const updateElement = (el, value, decimals, useSeparator) => {
      if (el.dataset.split === '1') {
        const intEl = el.querySelector('[data-count-part="int"]');
        const decEl = el.querySelector('[data-count-part="dec"]');
        if (intEl) {
          intEl.textContent = formatInteger(value, useSeparator);
        }
        if (decEl) {
          decEl.textContent = formatDecimalPart(value, decimals);
        }
        return;
      }
      if (decimals > 0) {
        el.textContent = `${formatInteger(value, useSeparator)}${formatDecimalPart(value, decimals)}`;
        return;
      }
      el.textContent = formatInteger(value, useSeparator);
    };

    const animate = (el) => {
      if (el.dataset.counted === '1') {
        return;
      }
      el.dataset.counted = '1';

      const end = parseFloat(el.dataset.countTo || '0');
      const decimals = parseInt(el.dataset.decimals || '0', 10);
      const useSeparator = el.dataset.separator === '1';
      const duration = 1.6;
      const counter = { value: 0 };

      gsap.to(counter, {
        value: end,
        duration,
        ease: 'none',
        onUpdate: () => {
          updateElement(el, counter.value, decimals, useSeparator);
        },
        onComplete: () => {
          updateElement(el, end, decimals, useSeparator);
        },
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    targets.forEach((el) => observer.observe(el));
  }
}

class PeopleSingle {
  constructor() {
    document.querySelectorAll('.js-people-swiper-other').forEach((swiperEl) => {
      const section = swiperEl.closest('.js-people-swiper-section');
      if (!section || swiperEl.swiper) {
        return;
      }

      const prevEl = section.querySelector('.js-people-other-prev');
      const nextEl = section.querySelector('.js-people-other-next');
      const nowEl = section.querySelector('.js-people-other-now');
      const totalEl = section.querySelector('.js-people-other-total');

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) {
        return;
      }

      const originalSlides = Array.from(wrapper.children);
      const slideCount = Number(swiperEl.dataset.slideCount) || originalSlides.length;
      if (slideCount <= 2) {
        return;
      }

      const enableLoop = slideCount > 1;

      const slidesPerViewPc = Number(swiperEl.dataset.slidesPerViewPc);
      const hasPcSlidesPerView = Number.isFinite(slidesPerViewPc) && slidesPerViewPc > 0;

      const syncSlideWidths = () => {
        const isSp = window.matchMedia('(max-width: 767px)').matches;
        if (!isSp && hasPcSlidesPerView) {
          swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
            slide.style.width = '';
            slide.style.maxWidth = '';
          });
          return;
        }

        const widthPc = swiperEl.dataset.slideWidthPc || '36rem';
        const widthSp = swiperEl.dataset.slideWidthSp || '32rem';
        const width = isSp ? widthSp : widthPc;

        swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.style.width = width;
        });
      };

      if (enableLoop) {
        originalSlides.forEach((slide) => {
          wrapper.appendChild(slide.cloneNode(true));
        });
        originalSlides.forEach((slide) => {
          wrapper.appendChild(slide.cloneNode(true));
        });
      }

      syncSlideWidths();

      const getLogicalIndex = (swiper) => swiper.activeIndex % slideCount;

      const fixPosition = (swiper) => {
        const index = swiper.activeIndex;

        if (index < slideCount) {
          swiper.slideTo(index + slideCount, 0);
          return;
        }

        if (index >= slideCount * 2) {
          swiper.slideTo(index - slideCount, 0);
        }
      };

      const updatePagination = (swiper) => {
        if (!nowEl || !totalEl) {
          return;
        }

        totalEl.textContent = String(slideCount).padStart(2, '0');
        const current = enableLoop ? getLogicalIndex(swiper) + 1 : swiper.activeIndex + 1;
        nowEl.textContent = String(current).padStart(2, '0');
      };

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        speed: 500,
        loop: false,
        initialSlide: enableLoop ? slideCount : 0,
        watchOverflow: slideCount <= 1,
        breakpoints: {
          768: {
            spaceBetween: 40,
            ...(hasPcSlidesPerView
              ? {
                  slidesPerView: Math.min(slidesPerViewPc, slideCount),
                  centeredSlides: false,
                }
              : {}),
          },
        },
        on: {
          init() {
            syncSlideWidths();
            this.update();
            updatePagination(this);
          },
          resize() {
            syncSlideWidths();
            this.update();
          },
          slideChangeTransitionEnd() {
            if (enableLoop) {
              fixPosition(this);
            }
            updatePagination(this);
          },
        },
      });

      if (prevEl) {
        prevEl.addEventListener('click', (event) => {
          event.preventDefault();
          swiper.slidePrev();
        });
      }

      if (nextEl) {
        nextEl.addEventListener('click', (event) => {
          event.preventDefault();
          swiper.slideNext();
        });
      }

      swiperEl.swiper = swiper;
    });
  }
}

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

		const autoDelay = 1500;
		const fadeSpeed = 2500;
		// 表示サイクル（delay + fade）＋フェードアウト中も拡大が続くようにする
		const slideCycle = autoDelay + fadeSpeed;
		const zoomDuration = (slideCycle + fadeSpeed) / 1000;

		const getSlideBg = (slide) => slide && slide.querySelector(':scope > div');

		const getSlidesByRealIndex = (swiper, realIndex) => {
			return Array.from(swiper.slides).filter((slide) => {
				const index = slide.getAttribute('data-swiper-slide-index');
				return index !== null && Number(index) === realIndex;
			});
		};

		const zoomActiveSlide = (swiper) => {
			const targets = getSlidesByRealIndex(swiper, swiper.realIndex)
				.map(getSlideBg)
				.filter(Boolean);

			if (!targets.length) {
				const fallback = getSlideBg(swiper.slides[swiper.activeIndex]);
				if (fallback) targets.push(fallback);
			}

			targets.forEach((activeBg) => {
				gsap.killTweensOf(activeBg);
				gsap.fromTo(activeBg,
					{ scale: 1 },
					{
						scale: 1.1,
						duration: zoomDuration,
						ease: 'linear'
					}
				);
			});
		};

		const resetInactiveSlides = (swiper) => {
			const activeSlides = new Set(getSlidesByRealIndex(swiper, swiper.realIndex));

			swiper.slides.forEach((slide) => {
				if (activeSlides.has(slide)) return;
				const bg = getSlideBg(slide);
				if (!bg) return;
				gsap.killTweensOf(bg);
				gsap.set(bg, { scale: 1 });
			});
		};

		let swiperMv = null;

		// function splitTextKeepBr(target) {
		// 	const els = document.querySelectorAll(target);
		// 	if (!els.length) return;
		
		// 	els.forEach((el) => {
		// 		const nodes = Array.from(el.childNodes);
		// 		el.innerHTML = '';
		
		// 		nodes.forEach((node) => {
		// 			// テキストノードだけ1文字ずつspan化
		// 			if (node.nodeType === Node.TEXT_NODE) {
		// 				const text = node.textContent;
		
		// 				text.split('').forEach((char) => {
		// 					const span = document.createElement('span');
		
		// 					if (char === ' ') {
		// 						span.innerHTML = '&nbsp;';
		// 					} else {
		// 						span.textContent = char;
		// 					}
		
		// 					el.appendChild(span);
		// 				});
		// 			}
		
		// 			// brはそのまま戻す
		// 			if (node.nodeName === 'BR') {
		// 				el.appendChild(document.createElement('br'));
		// 			}
		// 		});
		// 	});
		// }
		
		// splitTextKeepBr('.js-mv-copy');
		// document.querySelectorAll('.js-mv-copy-line').forEach((line) => {
		// 	const text = line.innerHTML;
		// 	line.innerHTML = `<span>${text}</span>`;
		// });
	

		// =========================
		// Swiper 初期化
		// =========================
		function initMvSwiper() {
			if (swiperMv) return;

			swiperMv = new Swiper('.js-swiper-mv', {
				slidesPerView: 1,
				loop: true,
				speed: fadeSpeed,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: autoDelay,
					disableOnInteraction: false
				},
				allowTouchMove: false,
				on: {
					init: function () {
						// 文字アニメ完了まではタイマーを動かさない
						this.autoplay.stop();
					},

					slideChangeTransitionStart: function () {
						// 開始前の内部slideChangeでは拡大をやり直さない（縮小チラつき防止）
						if (!this._mvReady) return;
						zoomActiveSlide(this);
					},

					slideChangeTransitionEnd: function () {
						if (!this._mvReady) return;
						resetInactiveSlides(this);
					}
				}
			});
		}

		function startMvSwiper() {
			if (!swiperMv || swiperMv._mvReady) return;

			requestAnimationFrame(() => {
				zoomActiveSlide(swiperMv);
				swiperMv._mvReady = true;
				// 2枚目以降: フェードイン(fadeSpeed) + delay のあとで切り替わる
				// 1枚目は最初から表示済みなので、フェードイン相当を待ってから autoplay 開始
				setTimeout(() => {
					if (!swiperMv) return;
					swiperMv.autoplay.start();
				}, fadeSpeed - 500);
			});
		}


		// =========================
		// 初回セッションのみイントロを再生
		// =========================
		const MV_INTRO_KEY = 'tciMvIntroPlayed';
		let hasPlayedIntro = false;
		try {
			hasPlayedIntro = sessionStorage.getItem(MV_INTRO_KEY) === '1';
		} catch (e) {
			hasPlayedIntro = false;
		}

		const markIntroPlayed = () => {
			try {
				sessionStorage.setItem(MV_INTRO_KEY, '1');
			} catch (e) {}
		};

		if (hasPlayedIntro) {
			gsap.set('.js-mv-copy-line', { opacity: 1, y: 0 });
			gsap.set('.js-mv-subcopy', { opacity: 1, y: 0 });
			gsap.set('.js-mv-item', { opacity: 1 });
			gsap.set('.p-top', {
				opacity: 0
			});

			initMvSwiper();
			startMvSwiper();

			gsap.to('.p-top', {
				opacity: 1,
				duration: 0.2,
				ease: 'power2.out'
			});
		} else {
			// =========================
			// 初期状態
			// =========================
			gsap.set('.p-top', {
				opacity: 0
			});

			gsap.set('.js-mv-copy-line', {
				opacity: 0,
				y: '7rem'
			});

			gsap.set('.js-mv-subcopy', {
				opacity: 0,
				y: '1rem'
			});

			gsap.set('.js-mv-item', {
				opacity: 0
			});

			// =========================
			// MV表示アニメーション
			// =========================
			const mvTl = gsap.timeline({
				onStart: markIntroPlayed
			});

			mvTl
			.call(initMvSwiper)
			.to('.p-top', {
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out'
			})

			.to('.js-mv-copy-line', {
				y: 0,
				opacity: 1,
				duration: 1.0,
				ease: 'power3.out',
				stagger: 0.1
			}, 1) // テキスト出現開始を1秒後に

			.to('.js-mv-subcopy', {
				opacity: 1,
				y: 0,
				duration: 0.8,
				ease: 'power3.out'
			}, '<-=0.02')

			// 文字が出揃ってからスライド時間（autoplay / zoom）を開始
			.call(startMvSwiper)

			.to('.js-mv-item', {
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out'
			});
		}
		
		// const swiperMv = new Swiper('.js-swiper-mv', {
		// 	slidesPerView: 1,
		// 	loop: true,
		// 	speed: fadeSpeed,
		// 	effect: 'fade',
		// 	fadeEffect: {
		// 		crossFade: true
		// 	},
		// 	autoplay: {
		// 		delay: autoDelay,
		// 		disableOnInteraction: false
		// 	},
		// 	allowTouchMove: false,
		// 	on: {
		// 		init(swiper) {
		// 			requestAnimationFrame(() => {
		// 				zoomActiveSlide(swiper);
		// 			});
		// 		},
		
		// 		slideChangeTransitionStart(swiper) {
		// 			// 次に表示されるスライドだけ拡大開始
		// 			zoomActiveSlide(swiper);
		// 		},
		
		// 		slideChangeTransitionEnd(swiper) {
		// 			// フェードが終わって、見えなくなってから他スライドをリセット
		// 			resetInactiveSlides(swiper);
		// 		}
		// 	}
		// });

		const peopleSwiperEl = document.querySelector('.js-people-swiper');
		if (peopleSwiperEl) {
			// loop 複製前の本来の枚数（複製後に数えるとずれる）
			const peopleSlideCount = peopleSwiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

			const updatePeoplePagination = (swiper) => {
				const total = swiper.params.loop
					? peopleSlideCount
					: swiper.slides.length;
				const totalEl = peopleSwiperEl.querySelector(".js-total-num");
				const nowEl = peopleSwiperEl.querySelector(".js-now-num");
				if (totalEl) {
					totalEl.textContent = String(total).padStart(2, "0");
				}
				if (nowEl) {
					nowEl.textContent = String(swiper.realIndex + 1).padStart(2, "0");
				}
			};

			// init 内の slideToLoop は loop 未完成のまま DOM 先頭（最終スライドの複製）へ飛ぶことがある
			const swiper = new Swiper(peopleSwiperEl, {
				loop: peopleSlideCount > 1,
				slidesPerView: 1.2,
				centeredSlides: true,
				spaceBetween: 20,
				initialSlide: 0,
				loopedSlides: peopleSlideCount,
				loopAdditionalSlides: peopleSlideCount,
				threshold: 10,
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 0,
						centeredSlides: true,
						slidesOffsetAfter: 900,
					}
				},
				navigation: {
					prevEl: ".js-people-prev",
					nextEl: ".js-people-next"
				},
				on: {
					init: function () {
						updatePeoplePagination(this);
					},
					slideChange: function () {
						updatePeoplePagination(this);
					},
				}
			});

			// loop 時は先頭に最終スライドの複製が並ぶため、実スライド先頭（loopedSlides）へ合わせる
			// ※init 内の slideToLoop(0) だと複製先頭＝最終記事に飛ぶことがある
			if (peopleSlideCount > 1) {
				requestAnimationFrame(() => {
					swiper.slideTo(swiper.loopedSlides || 0, 0);
					updatePeoplePagination(swiper);
				});
			}
		}

		const workSwiperEl = document.querySelector('.js-work-swiper');

		if (workSwiperEl) {
			const workPcQuery = window.matchMedia('(min-width: 768px)');
			const workTotal = workSwiperEl.querySelectorAll('.swiper-slide').length;
			const workNowNumEl = workSwiperEl.querySelector('.js-work-now-num');
			const workTotalNumEl = workSwiperEl.querySelector('.js-work-total-num');
			let workSwiper = null;

			if (workTotalNumEl) {
				workTotalNumEl.textContent = String(workTotal).padStart(2, "0");
			}

			const setWorkCurrent = (swiper, isPc) => {
				// PCは左端に前のスライドを見せ、その右隣（左から2番目）をcurrentにする
				const currentSlide = swiper.slides[swiper.activeIndex + (isPc ? 1 : 0)];

				swiper.slides.forEach((slide) => {
					slide.classList.toggle('is-current', slide === currentSlide);
				});

				if (!currentSlide || !workNowNumEl) return;

				// ループ複製スライドは元スライドの番号を持つ
				const slideIndex = currentSlide.getAttribute('data-swiper-slide-index');
				const current = slideIndex === null ? swiper.activeIndex : Number(slideIndex);

				workNowNumEl.textContent = String(current + 1).padStart(2, "0");
			};

			// SPはコンテナの左paddingとスライド間の余白を揃えることで、前のスライドがちょうど画面外に隠れる
			const getWorkSpaceBetween = (isPc) => {
				if (isPc) return 20;
				return parseFloat(getComputedStyle(workSwiperEl).paddingLeft) || 20;
			};

			const initWorkSwiper = (isPc) => {
				if (workSwiper) {
					workSwiper.destroy(true, true);
					workSwiper = null;
				}

				workSwiper = new Swiper(workSwiperEl, {
					// 幅はCSS固定（PC:35×53 / SP:26.4×40）のため auto で縦横比を維持
					slidesPerView: 'auto',
					spaceBetween: getWorkSpaceBetween(isPc),
					centeredSlides: false,
					loop: true,
					loopAdditionalSlides: 3,
					slidesOffsetAfter: isPc ? 900 : 0,
					threshold: 10,
					// 最終スライドを左端に置くことで、ライフサイエンスが最初のcurrentになる
					initialSlide: isPc ? Math.max(workTotal - 1, 0) : 0,

					navigation: {
						prevEl: ".js-work-prev",
						nextEl: ".js-work-next"
					},

					on: {
						init: function () {
							setWorkCurrent(this, isPc);
						},

						activeIndexChange: function () {
							setWorkCurrent(this, isPc);
						},

						loopFix: function () {
							setWorkCurrent(this, isPc);
						},

						// remは画面幅連動のため、リサイズ後もpaddingと余白を揃え直す
						resize: function () {
							this.params.spaceBetween = getWorkSpaceBetween(isPc);
							this.update();
						}
					}
				});
			};

			initWorkSwiper(workPcQuery.matches);

			workPcQuery.addEventListener('change', (event) => {
				initWorkSwiper(event.matches);
			});
		}
	
	
	}
}
class Works {
  constructor() {
		const workSwiperEl = document.querySelector('.js-other-works-swiper');

		if (!workSwiperEl) {
			return;
		}

		let swiper = null;
		let fitsAll = null;

		const getOriginalSlides = () =>
			Array.from(workSwiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));

		const allSlidesFit = () => {
			const slides = getOriginalSlides();
			if (!slides.length) {
				return true;
			}

			const spaceBetween = 20;
			const totalWidth = slides.reduce(
				(sum, slide, i) => sum + slide.offsetWidth + (i < slides.length - 1 ? spaceBetween : 0),
				0
			);

			return totalWidth <= workSwiperEl.clientWidth + 1;
		};

		const updatePagination = (instance) => {
			const total = instance.params.loop
				? instance.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length
				: instance.slides.length;

			workSwiperEl.querySelector('.js-other-works-total').textContent =
				String(total).padStart(2, '0');
			workSwiperEl.querySelector('.js-other-works-now').textContent =
				String(instance.realIndex + 1).padStart(2, '0');
		};

		const initSwiper = () => {
			const nextFitsAll = allSlidesFit();

			if (swiper && fitsAll === nextFitsAll) {
				swiper.update();
				return;
			}

			fitsAll = nextFitsAll;
			workSwiperEl.classList.toggle('is-slides-fit', fitsAll);

			if (swiper) {
				swiper.destroy(true, true);
				swiper = null;
			}

			swiper = new Swiper(workSwiperEl, {
				// 幅はCSS固定（PC:35×45 / SP:26.4×40）のため auto で縦横比を維持
				slidesPerView: 'auto',
				centeredSlides: true,
				spaceBetween: 20,
				loop: false,
				loopFillGroupWithBlank: true,
				watchOverflow: true,
				allowTouchMove: !fitsAll,
				breakpoints: {
					768: fitsAll
						? {
								loop: false,
								slidesPerView: 'auto',
								spaceBetween: 20,
								centeredSlides: false,
								slidesOffsetAfter: 0,
							}
						: {
								loop: true,
								slidesPerView: 'auto',
								spaceBetween: 20,
								centeredSlides: false,
								slidesOffsetAfter: 900,
							}
				},

				navigation: {
					prevEl: '.js-other-works-prev',
					nextEl: '.js-other-works-next'
				},

				on: {
					init: function () {
						updatePagination(this);
					},

					slideChange: function () {
						workSwiperEl.querySelector('.js-other-works-now').textContent =
							String(this.realIndex + 1).padStart(2, '0');
					},
				}
			});
		};

		initSwiper();
		window.addEventListener('resize', initSwiper);
	}
}

class Accordion {
  constructor(selector = '.js-accordion', opt = {}) {
    this.selector = selector;
    this.multiple = opt.multiple || false;
    this.speed = opt.speed || 400;
    this.$accordions = $(selector);

    if (!this.$accordions.length) {
      return;
    }

    this.initState();
    this.event();
  }

  initState() {
    this.$accordions.each((_, accordion) => {
      $(accordion).find('.js-accordion-item').each((__, item) => {
        const $item = $(item);
        const $content = $item.find('.js-accordion-content');

        if (!$content.length) {
          return;
        }

        if ($item.hasClass('is-open')) {
          $content.show();
        } else {
          $content.hide();
        }
      });
    });
  }

  event() {
    this.$accordions.on('click', '.js-accordion-trigger', (e) => {
      e.preventDefault();

      const $trigger = $(e.currentTarget);
      const $item = $trigger.closest('.js-accordion-item');
      const $accordion = $trigger.closest(this.selector);
      const $content = $item.find('.js-accordion-content');

      if (!$content.length) {
        return;
      }

      const isOpen = $item.hasClass('is-open');

      if (isOpen) {
        $item.removeClass('is-open');
        $content.slideUp(this.speed);
        return;
      }

      if (!this.multiple) {
        $accordion.find('.js-accordion-item.is-open').each((_, openItem) => {
          const $openItem = $(openItem);

          if ($openItem.is($item)) {
            return;
          }

          $openItem.removeClass('is-open');
          $openItem.find('.js-accordion-content').slideUp(this.speed);
        });
      }

      $item.addClass('is-open');
      $content.slideDown(this.speed);
    });
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {		
    var windowWidth = $(window).width();
    var windowSm = 768;
		if (windowWidth <= windowSm) {
			$('.js-h-content a').on('click', function() {
				$('html').removeClass('is-open');
				scrollBan();
			});
		
			$('.js-mega-trigger').on('click', function(e) {
				// メガメニューのアコーディオン制御は「トリガー領域」のみで行い、
				// 配下のリンクタップは遷移を優先する
				if ($(e.target).closest('a').length) {
					return;
				}
				e.preventDefault();
			
				$(this).toggleClass('is-active');
				$(this).find('.js-mega-trigger-plus').toggleClass('is-active');
				$(this).find('.js-mega-content').slideToggle();
			});
		
		} else {
			// トリガー〜パネル間のわずかな隙間で閉じないよう、leave時に短い遅延を入れる
			let megaCloseTimer = null;

			$('.js-mega-trigger').on('mouseenter', function() {
				clearTimeout(megaCloseTimer);
				const $trigger = $(this);
				$('.js-mega-trigger').not($trigger).removeClass('is-active')
					.find('.js-mega-content, .js-mega-trigger-plus').removeClass('is-active');
				$trigger.addClass('is-active');
				$trigger.find('.js-mega-content').addClass('is-active');
				$trigger.find('.js-mega-trigger-plus').addClass('is-active');
			}).on('mouseleave', function() {
				const $trigger = $(this);
				megaCloseTimer = setTimeout(function() {
					$trigger.removeClass('is-active');
					$trigger.find('.js-mega-content').removeClass('is-active');
					$trigger.find('.js-mega-trigger-plus').removeClass('is-active');
				}, 200);
			});
		}
    
    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    // スマホメニュー内のクリック
    $('.js-header').find('a').click(function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    let scrollTop = 0;

    // html固定スクロール禁止/解除（引数なし=toggle / true=lock / false=unlock）
    const scrollBan = (() => {
      const html = document.documentElement; // $('html')[0] と同じ
      let locked = false;
      let scrollTop = 0;

      const lock = () => {
        if (locked) return;
        locked = true;

        scrollTop = window.scrollY || 0;

        // 現在位置を固定
        html.style.top = `${-scrollTop}px`;
        html.classList.add("is-hidden");
      };

      const unlock = () => {
        if (!locked && !html.classList.contains("is-hidden")) return;
        locked = false;

        // scroll-behavior を一時的に auto にして瞬間復帰
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";

        html.style.top = "";
        html.classList.remove("is-hidden");

        window.scrollTo(0, scrollTop);

        // 次フレームで元に戻す（0ms setTimeout より安全）
        requestAnimationFrame(() => {
          html.style.scrollBehavior = prevScrollBehavior;
        });
      };

      // state: true=lock / false=unlock / undefined=toggle
      return (state) => {
        if (typeof state === "boolean") {
          state ? lock() : unlock();
          return locked;
        }
        locked ? unlock() : lock();
        return locked;
      };
    })();
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

(() => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let top = new Top('p-top');
  let headerMenu = new HeaderMenu('js-header');
  new PeopleSingle();
  new DataPage();
  new AboutPage();
  new Accordion('.js-internship-accordion', { multiple: true });
  let works = new Works('p-works');
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
});